import httpClient from "../httpClient";
import { API_CASE_SINGLE } from "../config";

const getSingleCaseInfo = {
    caseInfo: (id,) => httpClient.get(API_CASE_SINGLE + '/' + id),
};

export default getSingleCaseInfo;
